import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VendorService from "../../../services/VendorServices";
import VendorCategoryService from "../../../services/VendorCategoryService";
import Breadcrumb from "../../../components/Breadcrumb";
import StorageService from "../../../services/StorageService";
import ListVendor from "../Components/ListVendor";
import ViewModelVendor from "../Components/ViewModelVendor";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewVendor() {
  const [vendors, setVendors] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showCatDropdown, setShowCatDropdown] = useState(false);
  const [categorySearchText, setCategorySearchText] = useState("");
  const categoryDropdownRef = useRef(null);

  const [selected, setSelected] = useState(null); // single select (radio)
  const [searchTerm, setSearchTerm] = useState(""); // search
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("success");
  // const messageTimer = useRef(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const showMessage = (text, type = "success") => {
    setMessage(text);
    setMsgType(type);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
        setShowCatDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await VendorCategoryService.getActive();
        const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        setVendorCategories(list);
      } catch (err) {
        console.error("Error loading vendor categories:", err);
      }
    };
    fetchCategories();
  }, []);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const res = await VendorService.getAll(currentPage, itemsPerPage, searchTerm, selectedCategory);

      // backend now returns { data, totalPages, currentPage }
      const list = Array.isArray(res?.data) ? res.data : [];
      setVendors(list);
      setPageCount(res?.totalPages || 1);

    } catch (error) {
      console.error("Vendor load error:", error);
      showMessage("Failed to load vendors", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, [currentPage, searchTerm, selectedCategory]);




  const handleAdd = () => navigate("/cpnl/vendors/add");

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleModify = () => {
    if (!selected) {
      showMessage("Please select a vendor to modify.", "error");
      return;
    }

    if (selected.status !== "Active") {
      showMessage("Inactive vendors cannot be modified.", "error");
      return;
    }

    navigate(`/cpnl/vendors/add/${selected.id}`);
  };

  const handleView = async () => {
    if (!selected) {
      showMessage("Please select a vendor to view.", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await VendorService.getById(selected.id);
      const data = res?.data?.data || res?.data || res;

      if (!data) {
        showMessage("Failed to load vendor details!", "error");
        return;
      }

      setViewData(data);
      setShowViewModal(true);
    } catch (err) {
      console.error(err);
      showMessage("Error loading vendor details.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    const vendor = vendors.find((v) => v.id === id);
    if (!vendor) return;

    const confirmMsg =
      vendor.status === "Active"
        ? "Are you sure you want to change status to Inactive?"
        : "Are you sure you want to change status to Active?";

    if (!window.confirm(confirmMsg)) return;

    setLoading(true);
    try {
      await VendorService.updateStatus(id);
      showMessage(
        vendor.status === "Active"
          ? "Vendor inactivated successfully!"
          : "Vendor activated successfully!",
        "success"
      );
      fetchVendors();
    } catch (error) {
      console.error(error);
      showMessage("Error updating vendor status.", "error");
    } finally {
      setLoading(false);
    }
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewData(null);
  };

  // const filteredVendors = vendors.filter(
  //   (v) =>
  //     v.vendorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     v.vendorCode?.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const filteredVendors = vendors;


  return (
    <>
      <Breadcrumb pageTitle="Vendors" secondTitle="Masters"></Breadcrumb>
      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}


          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />

          {/* TOP BUTTONS & FILTERS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3 flex-wrap">
            {/* Custom Searchable Vendor Category Dropdown */}
            <div className="position-relative" ref={categoryDropdownRef} style={{ width: "240px" }}>
              <div
                className="form-select d-flex align-items-center justify-content-between"
                style={{ cursor: "pointer", backgroundColor: "#fff" }}
                onClick={() => setShowCatDropdown(prev => !prev)}
              >
                <span className="text-truncate" style={{ fontSize: "0.9rem" }}>
                  {selectedCategory
                    ? vendorCategories.find(c => String(c.id) === String(selectedCategory))?.vendorCategoryName || "Selected Category"
                    : "All Categories"}
                </span>
                {selectedCategory ? (
                  <i
                    className="ti ti-x text-muted ms-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedCategory("");
                      setCurrentPage(1);
                    }}
                  />
                ) : (
                  <i className="ti ti-chevron-down text-muted ms-1" style={{ fontSize: "0.8rem" }} />
                )}
              </div>

              {showCatDropdown && (
                <div
                  className="position-absolute start-0 mt-1 bg-white border rounded shadow p-2"
                  style={{ zIndex: 1050, width: "260px" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="mb-2 position-relative">
                    <input
                      type="text"
                      className="form-control form-control-sm pe-4"
                      placeholder="Search Category..."
                      value={categorySearchText}
                      onChange={(e) => setCategorySearchText(e.target.value)}
                      autoFocus
                    />
                    {categorySearchText && (
                      <i
                        className="ti ti-x position-absolute end-0 top-50 translate-middle-y me-2 text-muted"
                        style={{ cursor: "pointer", fontSize: "0.85rem" }}
                        onClick={() => setCategorySearchText("")}
                      />
                    )}
                  </div>

                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    <div
                      className={`px-2 py-1.5 rounded cursor-pointer ${!selectedCategory ? "bg-primary text-white fw-bold" : "text-dark"}`}
                      style={{ cursor: "pointer", fontSize: "0.88rem" }}
                      onClick={() => {
                        setSelectedCategory("");
                        setCurrentPage(1);
                        setShowCatDropdown(false);
                        setCategorySearchText("");
                      }}
                    >
                      All Categories
                    </div>

                    {vendorCategories
                      .filter((cat) =>
                        cat.vendorCategoryName.toLowerCase().includes(categorySearchText.toLowerCase())
                      )
                      .map((cat) => (
                        <div
                          key={cat.id}
                          className={`px-2 py-1.5 rounded cursor-pointer mt-1 ${
                            String(selectedCategory) === String(cat.id) ? "bg-primary text-white fw-bold" : "text-dark"
                          }`}
                          style={{ cursor: "pointer", fontSize: "0.88rem" }}
                          onMouseEnter={(e) => {
                            if (String(selectedCategory) !== String(cat.id)) {
                              e.currentTarget.style.backgroundColor = "#f1f5f9";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (String(selectedCategory) !== String(cat.id)) {
                              e.currentTarget.style.backgroundColor = "transparent";
                            }
                          }}
                          onClick={() => {
                            setSelectedCategory(cat.id);
                            setCurrentPage(1);
                            setShowCatDropdown(false);
                            setCategorySearchText("");
                          }}
                        >
                          {cat.vendorCategoryName}
                        </div>
                      ))}

                    {vendorCategories.filter((cat) =>
                      cat.vendorCategoryName.toLowerCase().includes(categorySearchText.toLowerCase())
                    ).length === 0 && (
                      <div className="text-muted text-center py-2" style={{ fontSize: "0.85rem" }}>
                        No category found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Vendor"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>


            <div className="ms-auto d-flex gap-2">
              <button className="btn btn-success" onClick={handleAdd} disabled={loading}>
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button className="btn btn-warning" onClick={handleModify} disabled={loading}>
                <i className="ti ti-pencil me-1"></i> Modify
              </button>

              <button className="btn btn-primary" onClick={handleView} disabled={loading}>
                <i className="ti ti-eye me-1"></i> View
              </button>
            </div>
          </div>

          <ListVendor
            loading={loading}
            filteredVendors={filteredVendors}
            selected={selected}
            setSelected={setSelected}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </div>
      </div>

      <ViewModelVendor
        showViewModal={showViewModal}
        viewData={viewData}
        closeViewModal={closeViewModal}
      />
    </>
  );
}
